import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FloatingButton from "../../FloatingButton";

const Footer = () => {
  const [facebookHeight, setFacebookHeight] = useState(500);

  useEffect(() => {
    // Function to update height based on window width
    const updateHeight = () => {
      if (window.innerWidth > 1800) {
        setFacebookHeight(500);
      } else {
        setFacebookHeight(500);
      }
    };

    // Set initial height
    updateHeight();

    // Add event listener for window resize
    window.addEventListener('resize', updateHeight);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return (
    <>
      <section className="footer-con position-relative">
        <div id="footer-special-container" className="container">
          <div className="middle_portion">
            <div className="row">
              <div className="col-lg-2 col-md-12 col-sm-6 col-12 order-md-1 order-sm-1 order-1">
                <a href="index.html">
                  <figure className="footer-logo mb-0">
                    <img
                      className="img-fluid responsive-logo"
                      src="https://res.cloudinary.com/dtivafy25/image/upload/v1754646899/Derby.1_ilh013.pnghttps://res.cloudinary.com/dtivafy25/image/upload/v1754647692/Logo2_zepgoa.png"
                      alt="image-0"
                    />
                  </figure>
                </a>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 col-12 order-md-2 order-sm-4 order-2">
                <div className="links">
                  <h5 className="heading">Navigation</h5>
                  <div className="pages">
                    <ul className="list-unstyled mb-0 list1">
                      <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/">Home</Link>
                      </li>
                      <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/lollipops">Lollipops</Link>
                      </li>
                      <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/candies">Candies</Link>
                      </li>
                         <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/privacy">Privacy</Link>
                      </li>
                    </ul>

                    <ul className="list-unstyled mb-0 list1">
                      <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/toffees">Toffees</Link>
                      </li>
                      <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/premia">Premia</Link>
                      </li>
                      <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/terms">Terms</Link>
                      </li>
                         <li className="display-footer-links-inline">
                        <i className="fas fa-circle"></i>
                        <Link to="/cancellation-policy">Cancellation</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="icon">
                  <ul
                    style={{ display: "flex", paddingLeft: "2.5vw" }}
                    className="list-unstyled mb-3 social-icons"
                  >
                    <li>
                      <button
                        onClick={() => window.open("https://www.facebook.com/derbyconfectionery/", "_blank")}
                        aria-label="Facebook"
                        title="Facebook"
                        style={{ background: "none", border: "none", padding: 0 }}
                      >
                        <i className="fa-brands fa-facebook-f" aria-hidden="true"></i>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => window.open("https://x.com/derbyindia?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor", "_blank")}
                        aria-label="Twitter"
                        title="Twitter"
                        style={{ background: "none", border: "none", padding: 0 }}
                      >
                        <i className="fa-brands fa-x-twitter" aria-hidden="true"></i>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => window.open("https://www.instagram.com/derbyindia/?hl=en", "_blank")}
                        aria-label="Instagram"
                        title="Instagram"
                        style={{ background: "none", border: "none", padding: 0 }}
                      >
                        <i className="fa-brands fa-instagram" aria-hidden="true"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6 col-12 order-md-3 order-sm-3 order-3">
                <div className="info">
                  <ul className="list-unstyled mb-0">
                    <li>
                      <i className="fa-solid fa-location-dot"></i>
                      <div className="text">
                        <span>Address:</span>
                        <a
                          href="https://www.google.com/maps/place/121+King+St,+Melbourne+VIC+3000,+Australia/@-37.8172467,144.9532001,17z/data=!3m1!4b1!4m6!3m5!1s0x6ad65d4dd5a05d97:0x3e64f855a564844d!8m2!3d-37.817251!4d144.955775!16s%2Fg%2F11g0g8c54h?entry=ttu"
                          className="text-decoration-none address mb-0"
                        >
                          Plot No. N 75/1 Additional Anand Nagar MIDC Anand Nagar, East, Ambernath, Maharashtra 421506
                        </a>
                      </div>
                    </li>
                    <li>
                      <i className="fas fa-envelope-open-text"></i>
                      <div className="text">
                        <span>Email:</span>
                        <a
                          href="mailto:info@icedelights.com"
                          className="text-decoration-none"
                        >
                          contact@derbyindia.in
                        </a>
                      </div>


                    </li>
                    <div className="phone_wrapper">
                      <i className="fa-solid fa-phone phone"></i>
                      <div className="phone_content">
                        <a
                          href="tel:+919322986301"
                          className="text-decoration-none d-block"
                        >
                          +91 9322986301
                        </a>
                        <span>Got Questions? Call us 24/7</span>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-sm-6 col-12 order-md-4 order-sm-2 order-4">

                {/* Facebook Feed Section with Responsive Height */}
                <div className="footer-section">
                  <div className="facebook-feed">
                    <iframe
                      src="https://www.facebook.com/v9.0/plugins/page.php?adapt_container_width=true&amp;app_id=113869198637480&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df310a21b6f5a654%26domain%3Ddevelopers.facebook.com%26origin%3Dhttps%253A%252F%252Fdevelopers.facebook.com%252Ff3cf179cd85d47c%26relation%3Dparent.parent&amp;container_width=340&amp;height=500&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2F/derbyconfectionery/&amp;locale=en_US&amp;sdk=joey&amp;show_facepile=true&amp;small_header=false&amp;tabs=timeline&amp;width=500"
                      width="100%"
                      height={facebookHeight}
                      className="facebook-iframe"
                      style={{ border: 'none', overflow: 'hidden' }}
                      scrolling="no"
                      frameBorder="0"
                      allowFullScreen={true}
                      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                      title="Facebook Feed"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p className="mb-0">
            Copyright © {new Date().getFullYear()} Derby. All rights reserved.
          </p>
          <p>Created By <a style={{ color: '#ffffff', textDecoration: 'underline' }} target="blank" href="https://www.pitamaas.com/">Pitamaas Pvt. Ltd.</a></p>
        </div>
      </section>
      <FloatingButton />
    </>
  );
};

export default Footer;